import React from 'react';
import Loading from "../../shared/components/misc/Loading";
import UpcomingPaymentItem from './UpcomingPaymentItem';
import moment from 'moment';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

const UpcomingPaymentsSection = ({
  callToAction,
  callToActionPath,
  loading,
  undueRepayments = [],
}) => {
  if (loading) return <Loading />;
  const MAX_TO_DISPLAY = 6

  const upcomingPayments = undueRepayments
                           .sort((amountA, amountB) => amountB.payment.total - amountA.payment.total)
                           .sort((dateA, dateB) => moment(dateA.due_date) - moment(dateB.due_date));

  const upcomingPaymentsCount = upcomingPayments.length;

  const callToActionProps  = isEmpty(callToActionPath) ? {} : {
    onClick: (_event) => { callToAction(callToActionPath) },
    "data-path": callToActionPath
  };

  function renderViewAllCta(){
    if (upcomingPayments.length < MAX_TO_DISPLAY)  return null;
    return (<li>
          <button
            data-testid="view-all-upcoming-payments-button"
            className="ds-btn --micro _outline -secondary _displayBlock _margin--auto"
            { ...callToActionProps }
          >
            View all upcoming payments
          </button>
        </li>
    );
  }

  return (
    <section>
      { upcomingPaymentsCount === 0
        ? null
        :<ul className="ds-list" data-testid="upcoming-payments-list">
            {upcomingPayments.slice(0, MAX_TO_DISPLAY)
              .map((payment, index) => {
              return (
                <UpcomingPaymentItem
                  loading={loading}
                  key={index}
                  payment={payment}
                />
              );
            })}
            { renderViewAllCta() }
        </ul>
      }
    </section>
  );
};

UpcomingPaymentsSection.propTypes = {
  callToAction: PropTypes.func,
  callToActionPath: PropTypes.string,
  loading: PropTypes.bool,
  undueRepayments: PropTypes.arrayOf(PropTypes.shape({
    loan_plan_id: PropTypes.number,
    due_date: PropTypes.string,
    updated_date: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    clearance: PropTypes.string,
    payment: PropTypes.shape({
      fee: PropTypes.number,
      interest: PropTypes.number,
      principal: PropTypes.number,
      total: PropTypes.number,
    }),
    status: PropTypes.string,
  })),
}

export default UpcomingPaymentsSection;



// WEBPACK FOOTER //
// ./src/features/home/components/UpcomingPaymentsSection.js